// Hook - lista transakcji (z opcjonalnym filter stage do load-more kolumny kanbana)
// GET /api/ui/sales-crm/deals

import { axios } from 'api';
import { useQuery, UseQueryOptions } from 'react-query';
import { ICommandResponseError as IError } from 'api/types';
import type { DealStage, IGetDealsResponse } from 'api/types/deals';

export interface IUseGetDealsParams {
  stage?: DealStage;
  clientId?: number;
  traderId?: string;
  page?: number;
  limit?: number;
}

const getDeals = (params: IUseGetDealsParams): Promise<IGetDealsResponse> =>
  axios.get(`/sales-crm/deals`, { params });

export const useGetDeals = (
  params: IUseGetDealsParams = {},
  options?: UseQueryOptions<IGetDealsResponse, IError>,
) =>
  useQuery<IGetDealsResponse, IError>(
    ['sales-crm-deals', params],
    () => getDeals(params),
    options,
  );
